import Phaser from 'phaser'

import GameScene from './game'
import TitleScene from './title'
import HudScene from './hud'
import EditorHudScene from './editorHud'
import NonEditorHudScene from './nonEditorHud'
import SharePopupScene from './sharePopup'
import BannerAdScene from './bannerAd'
import SkipLevelScene from './skipLevel'
import Touch from './touch'
import { AnalyticsWrapper, ANALYTICS_COMPLETE, ANALYTICS_START } from '/components/analyticsWrapper'
import { PokiWrapper } from '/components/pokiWrapper'

export const NUM_LEVELS = 16

function assets (loader) {
  loader.script('webfont', 'https://ajax.googleapis.com/ajax/libs/webfont/1.6.26/webfont.js')

  loader.atlas('images', 'textures/clc2-packed/images.png', 'textures/clc2-packed/images.json')
  loader.atlas('spritesheets', 'textures/clc2-sprites/spritesheets.png', 'textures/clc2-sprites/spritesheets.json')

  /*
  // TO BE PACKED:
  loader.image('editor_left', 'textures/editor_left.png')
  loader.image('editor_right', 'textures/editor_right.png')
  loader.image('editor_up', 'textures/editor_up.png')
  loader.image('editor_down', 'textures/editor_down.png')
  loader.image('editor_pos', 'textures/editor_pos.png')
  loader.image('corner', 'textures/corner.png')
  loader.image('obs_gun', 'textures/obstacle_gun.png')

  loader.atlas('images', 'textures/packed/images_n.png', 'textures/packed/images.json')
  loader.atlas('spritesheets', 'textures/spritesheets/spritesheets_q.png', 'textures/spritesheets/spritesheets.json')

  loader.spritesheet('unlocks', 'textures/unlocks.png', { frameWidth: 150, frameHeight: 150 })
  loader.spritesheet('unlocks_locked', 'textures/unlocks_locked.png', { frameWidth: 150, frameHeight: 150 })

  loader.image('stool', 'textures/stool.png')
  loader.image('screw', 'textures/screw.png')
  loader.image('play_btn', 'textures/play_btn.png')

  loader.image('fish', 'textures/fish.png')
  loader.image('penguin', 'textures/penguin.png')
  loader.image('turtle', 'textures/turtle.png')
  loader.image('turtle_head', 'textures/turtle_head.png')
  loader.image('pig', 'textures/pig.png')
  loader.image('pug', 'textures/pug.png')
  loader.image('jelly', 'textures/jelly.png')
  loader.image('pig_feet', 'textures/pig_feet.png')
  loader.image('fish_fin', 'textures/fish_fin.png')
  loader.image('penguin_feet', 'textures/penguin_feet.png')
  loader.image('mouse', 'textures/mouse.png')
  loader.image('racoon', 'textures/racoon.png')
  loader.image('dog', 'textures/dog.png')
  loader.image('panda', 'textures/panda.png')
  loader.image('cat', 'textures/cat.png')
  loader.image('black_cat', 'textures/black_cat.png')
  loader.image('white_cat', 'textures/white_cat.png')
*/
  // load individual levels:
  // for (var i = 1; i <= NUM_LEVELS; i++) {
  // loader.json('level' + i, 'levels/level' + i + '.json')
  // }

  // load batched levels:
  // loader.json('allLevels', 'levels/allLevels.json')
}

function spritesheets (textures) {
  sheet(textures, 'keyboard', 159, 107, 1)
  sheet(textures, 'confetti', 32, 32, 1)
  sheet(textures, 'unlocks', 150, 150, 19)
  sheet(textures, 'unlocks_locked', 150, 150, 19)
  sheet(textures, 'cake2', 202, 183, 3)
}

function sheet (textures, name, width, height, endFrame) {
  textures.addSpriteSheetFromAtlas(
    name,
    {
      atlas: 'spritesheets',
      frame: name,
      frameWidth: width,
      frameHeight: height,
      endFrame: endFrame
    }
  )
}

export default class LoadingScene extends Phaser.Scene {
  preload () {
    this.load.image('white', 'textures/white.png')
    this.started = false
    this.loadingFinished = false
    this.requiresDeviceRotation = false
  }

  // loadScenes loads multiple scenes here and returns the starting scene
  static loadScenes (manager) {
    manager.add('GameScene', GameScene, false)
    manager.add('TouchScene', Touch, false)
    manager.add('TitleScene', TitleScene, false)
    manager.add('HudScene', HudScene, false)
    manager.add('EditorHudScene', EditorHudScene, false)
    manager.add('NonEditorHudScene', NonEditorHudScene, false)
    manager.add('SharePopup', SharePopupScene, false)
    manager.add('BannerAdScene', BannerAdScene, false)
    manager.add('SkipLevelScene', SkipLevelScene, false)

    return 'GameScene'
  }

  startScenes () {
    if (this.started) {
      return
    }
    this.started = true

    this.scene.run('BannerAdScene')

    // PokiWrapper.commercialBreak(() => {
    this.scene.start(this.initialScene)
    // })
  }

  create () {
    assets(this.load, 2)

    const bar = this.add.image((this.scale.gameSize.width / 2) - 200, 360, 'white')
    bar.setDisplaySize(2, 80).setOrigin(0, 0.5)

    this.load.on('progress', progress => {
      bar.setDisplaySize(400 * progress, 80)
    })

    this.load.once('complete', () => {
      PokiWrapper.gameLoadingFinished()

      spritesheets(this.textures)

      this.tweens.add({ targets: [bar], alpha: 0, duration: 100 })

      this.initialScene = LoadingScene.loadScenes(this.scene)
      this.loadingFinished = true

      this.startScenes()

      AnalyticsWrapper.addProgressionEvent(ANALYTICS_COMPLETE, 'loading')
    })

    PokiWrapper.gameLoadingStart()
    this.load.start()

    AnalyticsWrapper.addProgressionEvent(ANALYTICS_START, 'loading')
  }
}
